
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DashboardLine/DashboardLine.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DashboardLine.html');
        
        var script = require('./DashboardLine.ts').default;
        module.exports = require('./DashboardLine.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    